import React, { ChangeEvent } from 'react'

import * as S from './styles'
import { useFilter } from './useFilter'
import { FilterTag, InputSearch, Text } from '@/components'
import { useScrollMouseWheel } from '@/hooks/useScrollMouseWheel'
import { FilterText } from '@/service/api/blog'

export type FilterContainerSelected = 'new' | 'popular'
export type FilterContainerOnClickTagParam = string

export interface FilterContainerProps {
  options: string[]
  selected: FilterContainerSelected
  selectedByCategory: string
  title: string
  text: FilterText
  onClick: (filter: FilterContainerSelected) => void
  onClickTag: (value: FilterContainerOnClickTagParam) => void
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  search: string
}
type FilterOption = {
  option: FilterContainerSelected
  label: string
}

export const FilterContainer: React.FC<FilterContainerProps> = ({
  options,
  selected,
  selectedByCategory,
  title,
  text,
  onClick,
  onClickTag,
  onChange,
  search,
}) => {
  const filterOptions: Array<FilterOption> = [
    { label: text.newLabel, option: 'new' },
    { label: text.popularLabel, option: 'popular' },
  ]

  const { scrollContainer } = useScrollMouseWheel(true)

  const { fontSizes } = useFilter()
  return (
    <S.Container>
      <InputSearch
        search={search}
        onChange={(e) => onChange(e)}
        placeholder={text.placeholderSearch}
        className="input-search"
      />
      <div className="top">
        <Text size={fontSizes.title} color="darkgray">
          {title}
        </Text>
        <div className="filterButtons">
          <p className="filter-label">{text.filterBy}</p>
          <div className="filter">
            {filterOptions.map((item) => (
              <S.Button
                key={item.option}
                selected={selected.includes(item.option)}
                onClick={() => onClick(item.option)}
              >
                {item.label}
              </S.Button>
            ))}
          </div>
        </div>
      </div>
      <div ref={scrollContainer} className="tags">
        {options.map((item) => (
          <FilterTag
            key={item}
            text={item}
            onClick={() => {
              onClickTag(item)
            }}
            selected={item === selectedByCategory}
          />
        ))}
      </div>
    </S.Container>
  )
}
